module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/$.html.js
// module id = 288
// module chunks = 0